/*!
 * @Author: leo
 * @Date: 2019-12-25 20:55:00
 * @Last Modified by: leo
 * @Last Modified time: 2019-12-25 20:55:00
 * @Instruduction: http 请求
 */

import axios from 'axios'
import { commonSuccessHandler, commonErrorHandler } from './common-handler'
import { HOST_PREFIX, HOST } from '@/config/env'
import { getToken } from '@/common/cookies'
import { isValidURL } from '@/common/utils'

export interface IProps {
    method: any
    url: string
    params: any
}

const ins = axios.create({
    baseURL: HOST + HOST_PREFIX,
    timeout: 200000
})

const axiosIns = axios.create({ timeout: 100000 })

const xhr = ({ method = 'get', url, params = null }: any): Promise<any> => {
    let instance = ins
    if (isValidURL(url)) instance = axiosIns
    
    instance.defaults.headers.common['Authorization'] = getToken() || ''
    params = { ...params, ts: Date.now() }
    switch (method) {
        case 'get':
            return instance.get(url, { params })
                .then(commonSuccessHandler)
                .catch(commonErrorHandler)
        case 'put':
            return instance.put(url, params)
                .then(commonSuccessHandler)
                .catch(commonErrorHandler)
        case 'delete':
            return instance.delete(url, { params })
                .then(commonSuccessHandler)
                .catch(commonErrorHandler)
        default:
            return instance.post(url, params)
                .then(commonSuccessHandler)
                .catch(commonErrorHandler)
    }
}

export default xhr
